import { Request, Util } from "@xt/xtbase";

const { XtAxios } = Request;
const { getOrigin } = Util;

const URL = getOrigin("www") + "/uaapi/user/";

export function getAvatarList(config) {
  return XtAxios.get(URL + "user/avatarList", config);
}
